// src/context.tsx
import { createContext } from "react";
var AnalyticsContext = createContext({
  page: () => {
  },
  track: () => {
  }
});

export {
  AnalyticsContext
};
//# sourceMappingURL=chunk-3PHLPIUN.mjs.map